import React from 'react';
import styled from 'styled-components';
import { parsePublicationsHTML, processHTMLContent } from './utils/archivosParser';
const ArchivosContainer = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 1rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem;
  }
`;

const Title = styled.h1`
  color: #8a2be2;
  text-align: center;
  margin-bottom: 2rem;
  font-size: clamp(1.5rem, 4vw, 2.5rem);

  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
  }
`;

const ArchivosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 1rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const ArchivoCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }

  @media (max-width: 480px) {
    padding: 0.75rem;
    
    &:hover {
      transform: none;
    }
  }
`;

const ArchivoTitle = styled.h3`
  color: #4a5d4e;
  margin-bottom: 1rem;
`;

const ArchivoDescription = styled.p`
  color: #666;
  line-height: 1.6;
`;

const DownloadButton = styled.a`
  display: inline-block;
  background-color: #cc99ff;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  text-decoration: none;
  margin-top: 1rem;
  
  &:hover {
    background-color: #8a2be2;
  }
`;

const BackButton = styled.button`
  background-color: #8a2be2;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 20px;
  cursor: pointer;
  font-size: 1rem;
  margin-bottom: 1rem;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #6a1b9a;
  }

  @media (max-width: 768px) {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }
`;

const ContentViewer = styled.div`
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 2rem auto;
  max-width: 800px;

  @media (max-width: 768px) {
    padding: 1rem;
    margin: 1rem auto;
  }

  @media (max-width: 480px) {
    padding: 0.75rem;
    margin: 0.5rem auto;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  h1, h2, h3, h4, h5, h6 {
    font-size: clamp(1.1rem, 2vw, 1.5rem);
    margin-bottom: 1rem;
  }

  p {
    font-size: clamp(0.9rem, 1.5vw, 1rem);
    line-height: 1.6;
  }
`;

const HTMLContent = styled.div`
  font-family: Arial, sans-serif;
  
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 1rem 0;
  }
  
  td, th {
    padding: 0.5rem;
    border: 1px solid #ddd;
  }
  
  a {
    color: #8a2be2;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
`

const Archivos = () => {
  const [archivos, setArchivos] = React.useState([]);
  const [selectedContent, setSelectedContent] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const testFileLoad = async () => {
    try {
      console.log('Probando carga de archivo...');
      const response = await fetch('publicaciones/enlaweb/enlaweb.htm');
      console.log('Response status:', response.status);
      const htmlContent = await response.text();
      console.log('HTML cargado, longitud:', htmlContent.length);
      console.log('Primeros 500 caracteres:', htmlContent.substring(0, 500));
    } catch (error) {
      console.error('Error en prueba:', error);
    }
  };

  React.useEffect(() => {
    const cargarArchivos = async () => {
      try {
        setLoading(true);
        setError(null);
        console.log('Cargando archivos desde: publicaciones/enlaweb/enlaweb.htm');
        const response = await fetch('publicaciones/enlaweb/enlaweb.htm');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const htmlContent = await response.text();
        console.log('HTML cargado, longitud:', htmlContent.length);
        const archivosData = await parsePublicationsHTML(htmlContent);
        console.log('Datos parseados:', archivosData);
        const archivosArray = archivosData.data || [];
        console.log('Archivos a renderizar:', archivosArray.length);
        setArchivos(archivosArray);
      } catch (error) {
        console.error('Error al cargar los archivos:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    cargarArchivos();
  }, []);

    const archivosToRender = Array.isArray(archivos) ? archivos : [];

    const handleArchivoClick = async (url, title) => {
      // Caso especial para las jornadas del velo
      if (url === 'actividades/areasdetrabajo/jornadas/velo.htm' || 
          title.includes('signos religiosos') || 
          title.includes('velo')) {
        window.location.href = '/velo';
        return;
      }

      // Verificar si la URL es externa
      const isExternal = url.startsWith('http://') || url.startsWith('https://');

      if (isExternal) {
        // Abrir URLs externas en una nueva pestaña
        window.open(url, '_blank', 'noopener,noreferrer');
      } else if (url.toLowerCase().endsWith('.pdf')) {
        // Abrir PDFs en una nueva pestaña
        window.open(url, '_blank', 'noopener,noreferrer');
      } else if (url.endsWith('.htm') || url.endsWith('.html')) {
        // Procesar contenido HTML interno
        const content = await processHTMLContent(url);
        if (content) {
          setSelectedContent(content);
        }
      } else {
        // Abrir otros tipos de archivos en una nueva pestaña
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    };

    const handleBack = () => {
      setSelectedContent(null);
    };

    const ContentViewer = ({ content }) => {
      if (!content) return null;

      if (content.isPDF) {
        return null; // Los PDFs se abren en nueva pestaña
      }

      return (
        <div className="content-viewer">
          <BackButton onClick={handleBack}>
            ← Volver a Archivos
          </BackButton>
          <style>{content.styles}</style>
          <h2>{content.title}</h2>
          {content.mainContent && (
            <div 
              className="main-content"
              dangerouslySetInnerHTML={{ __html: content.mainContent }} 
            />
          )}
          {/* Removemos tableContent para evitar duplicación */}
        </div>
      );
    };

    return (
      <ArchivosContainer>
        <Title>Archivos Históricos</Title>       
      
        {!loading && !error && selectedContent ? (
          <ContentViewer content={selectedContent} />
        ) : !loading && !error ? (
          <>

            <ArchivosGrid>
              {archivosToRender.length > 0 ? (
                archivosToRender.map((archivo, index) => (
                  <ArchivoCard key={`archivo-${index}`}>
                    <ArchivoTitle>{archivo.attributes.Title}</ArchivoTitle>
                    <ArchivoDescription>
                      {archivo.attributes.Description}
                    </ArchivoDescription>
                                            <DownloadButton 
                          onClick={() => handleArchivoClick(archivo.attributes.URL, archivo.attributes.Title)}
                        >
                          Ver más detalles
                        </DownloadButton>
                  </ArchivoCard>
                ))
              ) : (
                <div style={{ textAlign: 'center', padding: '2rem' }}>
                  <p>No se encontraron archivos para mostrar.</p>
                </div>
              )}
            </ArchivosGrid>
          </>
        ) : null}
      </ArchivosContainer>
    );
};

export default Archivos; 